// Curve (curvecompliance.com) marketing tracker, loaded per practice from the key set on TeamCare's External IDs tab.
type CurveFn = ((...args: unknown[]) => unknown) & { q?: unknown[][]; l?: number };

declare global {
  interface Window {
    Curve?: CurveFn;
  }
}

const SCRIPT_SRC = 'https://t.curvecompliance.com/t.js';

let loadedKey: string | null = null;
let ready = false;
// Events fired before the script finishes loading; flushed right after init.
let pending: Array<[string, Record<string, unknown>]> = [];

export function loadCurve(apiKey: string) {
  if (loadedKey) return;
  loadedKey = apiKey;

  const w = window;
  w.Curve = w.Curve || (function () {
    // eslint-disable-next-line prefer-rest-params
    ((w.Curve!.q = w.Curve!.q || [])).push(Array.from(arguments));
  } as CurveFn);
  w.Curve.l = Date.now();

  const script = document.createElement('script');
  script.async = true;
  script.src = SCRIPT_SRC;
  script.onload = () => {
    w.Curve!('init', apiKey);
    ready = true;
    pending.forEach(([event, props]) => w.Curve!('track', event, props));
    pending = [];
  };
  document.head.appendChild(script);
}

// Never pass patient identifiers (names, contact details, DOB) in props.
export function trackCurve(event: string, props: Record<string, unknown> = {}) {
  if (!loadedKey) return;
  if (ready && window.Curve) {
    window.Curve('track', event, props);
  } else {
    pending.push([event, props]);
  }
}
